import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Row, Skeleton } from "antd";

import partnersApi from "../../../apis/Partners.api";

const DashboardLatestCommunity = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);

	const [latestCommunity, setLatestCommunity] = useState({});
	const [numbers, setNumbers] = useState({
		view_num: 0,
		like_num: 0,
		comment_num: 0,
	});

	useEffect(() => {
		if (user?.id) {
			getCommunity();
		}
	}, [user]);

	const getCommunity = useCallback(async () => {
		setLoading(true);
		let param = {
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			offset: 0,
			pageSize: 1,
			pageType: "admin",
		};
		const res = await partnersApi.readCommunityList(param);
		if (res.code === 200) {
			const community = res.result?.communityDTOList?.[0];
			if (community) {
				setLatestCommunity(community);
				// view_num * (5 + (item?.id % 10 / 10)
				setNumbers({
					view_num: community?.view_num
						? community?.view_num * (5 + (community?.id % 10) / 10)
						: 0,
					like_num: community?.like_num ?? 0,
					comment_num: community?.comment_num ?? 0,
				});
			}
		}
		setLoading(false);
	}, []);

	return (
		<div className={`dashboard-body-each`}>
			<h2 className={`dashboard-each-title`}>최신 게시글 실적</h2>
			{Object.keys(latestCommunity).length ? (
				<>
					<div
						className={`dashboard-each-data-div`}
						style={{ border: "none", padding: 0 }}
					>
						{loading ? (
							<Row align={"middle"} style={{ gap: "2em" }} wrap={false}>
								<Skeleton.Avatar active={loading} size={"large"} block={true} />
								<Skeleton.Button
									active={loading}
									size={"large"}
									block={true}
									style={{
										height: "4.5em",
										width: "100%",
									}}
								/>
							</Row>
						) : (
							<div className={`dashboard-data-each contents-report`}>
								<p
									className={`comment-parents-circle`}
									style={{
										marginLeft: 0,
										whiteSpace: "nowrap",
									}}
								>
									{latestCommunity?.category_name}
								</p>
								<p className={`sub-title`}>
									{latestCommunity?.title}
									<p
										style={{
											textOverflow: "ellipsis",
											overflow: "hidden",
										}}
									>
										{latestCommunity?.body}
									</p>
								</p>
							</div>
						)}
					</div>
					<div className={`dashboard-each-data-div`}>
						<Skeleton
							loading={loading}
							active={loading}
							size={"large"}
							block={true}
							style={{
								height: "6em",
							}}
							paragraph={{
								rows: 2,
								width: "100%",
							}}
						>
							<div className={`dashboard-data-each`}>
								<p>조회 수</p>
								<p>{Math.ceil(numbers?.view_num)?.toLocaleString()}</p>
							</div>
							<div className={`dashboard-data-each`}>
								<p>댓글 수</p>
								<p>{numbers?.comment_num?.toLocaleString()}</p>
							</div>
							<div className={`dashboard-data-each`}>
								<p>좋아요 수</p>
								<p>{numbers?.like_num?.toLocaleString()}</p>
							</div>
						</Skeleton>
					</div>
				</>
			) : (
				<Row
					align={"middle"}
					style={{ width: "100%", flexDirection: "column", padding: "3em 0" }}
				>
					<img
						src={`/assets/images/warning.png`}
						alt={`warning-icon`}
						style={{
							width: "3.5em",
							height: "auto",
						}}
					/>
					<span
						style={{
							marginTop: "1em",
							color: "#adb5bd",
							fontSize: "1.2em",
							fontWeight: 500,
						}}
					>
						작성된 글이 없습니다.
					</span>
				</Row>
			)}
			<Link to={"/reports_analysis/contents"}>게시글 분석으로 이동</Link>
		</div>
	);
};

export default DashboardLatestCommunity;
